import Vue from "vue";
import VueRouter from "vue-router";

import Publico from "./components/layouts/Publico.vue";
import Inicio from "./pages/public/Inicio.vue";

import Auth from "./components/layouts/Auth.vue";
import InicioSesion from "./pages/auth/InicioSesion";

import Administrativo from "./components/layouts/Administrativo.vue";

import HomeAdmin from "./pages/admin/HomeAdmin.vue";

import SenasoftTablero from "./pages/admin/SenasoftTablero.vue"

import AliadoRegistrar from "./pages/admin/aliados/Registrar.vue";
import AliadoGestionar from "./pages/admin/aliados/Gestionar.vue";
import AliadoDetalles from "./pages/admin/aliados/Detalles.vue";
import AliadoActualizar from "./pages/admin/aliados/Actualizar.vue";

import CategoriaRegistrar from "./pages/admin/categorias/Registrar.vue";
import CategoriaGestionar from "./pages/admin/categorias/Gestionar.vue";
import CategoriaDetalles from "./pages/admin/categorias/Detalles.vue";
import CategoriaActualizar from "./pages/admin/categorias/Actualizar.vue";
import CategoriaAsociar from "./pages/admin/categorias/Asociar.vue";

import CompetenciaRegistrar from "./pages/admin/competencias/Registrar.vue";
import CompetenciaGestionar from "./pages/admin/competencias/Gestionar.vue";
import CompetenciaDetalles from "./pages/admin/competencias/Detalles.vue";
import CompetenciaActualizar from "./pages/admin/competencias/Actualizar.vue";

import CupoGestionar from "./pages/admin/cupos/Gestionar.vue";
import CuposDetalles from "./pages/admin/cupos/Detalles.vue";
import CupoGestionarAsignado from "./pages/admin/cupos/GestionarAsignados.vue";

import ParticipanteGestionar from "./pages/admin/participantes/Gestionar.vue";
import ParticipanteDetalle from "./pages/admin/participantes/Detalles.vue";

import LiderGestionar from "./pages/admin/lideres/Gestionar.vue";
import LiderDetalle from "./pages/admin/lideres/Detalles.vue";
import LiderCategoria from "./pages/admin/lideres/Categoria.vue";

import SenasoftReporte from "./pages/admin/reportes/Senasoft.vue";

import PersonasGestionar from "./pages/worldskills/personas/Gestionar";
import PersonaRegistrar from "./pages/worldskills/personas/Registrar";


import TableroWorldSkills from "./pages/worldskills/Tablero.vue";

import HabilidadGestionar from "./pages/worldskills/habilidades/Gestionar.vue";
import HabilidadRegistrar from "./pages/worldskills/habilidades/Registrar.vue";
import HabilidadDetalle from "./pages/worldskills/habilidades/Detalles.vue";
import HabilidadActualizar from "./pages/worldskills/habilidades/Actualizar.vue";

import HabilidadAsignar from "./pages/worldskills/habilidades/Asignar.vue";
import HabilidadDocumento from "./pages/worldskills/habilidades/Documentos.vue";

import CompetenciaWsRegistrar from "./pages/worldskills/competencias/Registrar.vue";
import CompetenciaWsGestionar from "./pages/worldskills/competencias/Gestionar.vue";
import CompetenciaWsDetalles from "./pages/worldskills/competencias/Detalles.vue";
import CompetenciaWsActualizar from "./pages/worldskills/competencias/Actualizar.vue";
import DocumentosGCompetencia from "./pages/worldskills/competencias/Documentos.vue";
import CompetenciaWsFases from "./pages/worldskills/competencias/Fases.vue";

import SedeRegistrar from "./pages/worldskills/sedes/Registrar.vue";
import SedeGestionar from "./pages/worldskills/sedes/Gestionar.vue";
import SedeDetalle from "./pages/worldskills/sedes/Detalles.vue";
import SedeActualizar from "./pages/worldskills/sedes/Actualizar.vue";
import SedeAsignar from "./pages/worldskills/sedes/Asignar.vue";

import ParticipanteWsGestionar from "./pages/worldskills/participantes/Gestionar.vue";
import ParticipanteWsDetalles from "./pages/worldskills/participantes/Detalles.vue";

import GanadorGestionar from "./pages/worldskills/evaluaciones/GestionarGanador.vue";
import GanadorDetalle from "./pages/worldskills/evaluaciones/DetallesGanador.vue";

import ExpertoGestionar from "./pages/worldskills/expertos_regional/Gestionar.vue";
import ExpertoDetalles from "./pages/worldskills/expertos_regional/Detalles.vue";
import ExpertoNacionalGestionar from "./pages/worldskills/expertos_nacional/Gestionar.vue";
import ExpertoNacionalDetalle from "./pages/worldskills/expertos_nacional/Detalles.vue";

import AcompananteGestionar from "./pages/worldskills/acompanantes/Gestionar.vue";
import AcompananteDetalles from "./pages/worldskills/acompanantes/Detalles.vue";

import WorldskillstReporte from "./pages/worldskills/reportes/Reportes.vue";

import UsuarioRegistrar from "./pages/administracion/usuarios/Registrar.vue";
import UsuarioGestionar from "./pages/administracion/usuarios/Gestionar.vue";
import UsuarioDetalles from "./pages/administracion/usuarios/Detalles.vue";
import UsuarioActualizar from "./pages/administracion/usuarios/Actualizar.vue";
import UsuarioPerfil from "./pages/administracion/usuarios/Perfil.vue";
import UsuarioImportar from "./pages/administracion/usuarios/Importar.vue";

import PerfilRegistrar from "./pages/administracion/perfiles/Registrar.vue";
import PerfilGestionar from "./pages/administracion/perfiles/Gestionar.vue";
import PerfilActualizar from "./pages/administracion/perfiles/Actualizar.vue";
import PerfilPermiso from "./pages/administracion/perfiles/Permisos.vue";


import ForowsRegistrar from "./pages/worldskills/forows/registrar.vue";
import ForoVuetify from "./pages/worldskills/forows/forovuetify.vue";
import MensajeVuetify from "./pages/worldskills/forows/mensajevuetify.vue";


// Campesena
import CampesenaCategoriaRegistrar from "./pages/campesena/categorias/Registrar.vue"
import CampesenaCategoriaGestionar from "./pages/campesena/categorias/Gestionar.vue"
import CampesenaCategoriaActualizar from "./pages/campesena/categorias/Actualizar.vue"
import CampesenaCategoriaDetalles from "./pages/campesena/categorias/Detalles.vue"


import CampesenaCompetenciasGestionar from "./pages/campesena/competencias/Gestionar.vue"
import CampesenaCompetenciasRegistrar from "./pages/campesena/competencias/Registrar.vue"
import CampesenaCompetenciaDetalles from "./pages/campesena/competencias/Detalles.vue"
import CampesenaCompetenciaActualizar from './pages/campesena/competencias/Actualizar.vue'

import CampesenaCompetenciaCategoriaGestionar from "./pages/campesena/competencias-saberes/Gestionar.vue"

import CampesenaAliadosGestionar from './pages/campesena/aliados/Gestionar.vue'
import CampesenaAliadosRegistrar from './pages/campesena/aliados/Registrar.vue'
import CampesenaAliadosDetalles from './pages/campesena/aliados/Detalles.vue'
import CampesenaAliadosActualizar from './pages/campesena/aliados/Actualizar.vue'

import CampesenaSaberRegistrar from './pages/campesena/saberes/Registrar.vue'
import CampesenaSaberDetalles from './pages/campesena/saberes/Detalles.vue'
import CampesenaSaberActualizar from './pages/campesena/saberes/Actualizar.vue'
import CampesenaSaberesGestionar from "./pages/campesena/saberes/Gestionar.vue"

import CampesenaCupoGestionar from './pages/campesena/cupos/Gestionar.vue'
import CampesenaCompetenciasSaberesGestionar from './pages/campesena/cupos/GestionarAsignados.vue'
import CampesenaCompetenciasSaberesDetalles from './pages/campesena/cupos/Detalles.vue'

import CampesenaCompetenciasParticipantesGestionar from './pages/campesena/participantes/Gestionar.vue'
import CampesenaCompetenciasParticipantesDetalle from './pages/campesena/participantes/Detalles.vue'

import CampesenaCompetenciaLideresGestionar from './pages/campesena/lideres/Gestionar.vue'
import CampesenaCompetenciaLideresDetalles from './pages/campesena/lideres/Detalles.vue'

import CampesenaTablero from './pages/campesena/tablero/CampesenaTablero.vue'
import CampesenaReporte from './pages/campesena/reportes/CampesenaReporte.vue'

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes: [
    // layout publico
    {
      path: "/",
      name: "public",
      component: Publico,
      redirect: { name: 'home' },
      children: [
        {
          path: "/home",
          name: "home",
          component: Inicio,
        }
      ]
    },


    // layout auth
    {
      path: "/auth",
      name: "auth",
      component: Auth,
      redirect: { name: 'inicio-sesion' },
      children: [
        {
          path: "/inicio-sesion",
          name: "inicio-sesion",
          component: InicioSesion,
        }
      ]
    },


    // layout administrativo
    {
      path: "/admin",
      name: "admin",
     
      component: Administrativo,
      redirect: { name: 'home-admin' },
      children: [
        {
          path: '/home/admin',
          name: 'home-admin',
          component: HomeAdmin
        },

        /* ----- Administracion ----- */
        // usuarios
        { 
          path: "/usuarios", 
          name: "usuario-gestionar", 
          component: UsuarioGestionar 
        },

        {
          path: "/usuarios/registrar",
          name: "usuario-registrar",
          component: UsuarioRegistrar,
        },

        {
          path: "/usuarios/detalles/:id_usuario",
          name: "usuario-detalles",
          component: UsuarioDetalles,
        },

        {
          path: "/usuarios/actualizar/:id_usuario",
          name: "usuario-actualizar",
          component: UsuarioActualizar,
        },

        {
          path: "/usuarios/importar",
          name: "usuario-importar",
          component: UsuarioImportar,
        },

        {
          path: "/usuarios/perfil/:id_usuario",
          name: "usuario-perfil",
          component: UsuarioPerfil,
        },


        // perfiles
        { 
          path: "/perfiles", 
          name: "perfil-gestionar", 
          component: PerfilGestionar 
        },

        {
          path: "/perfiles/registrar",
          name: "perfil-registrar",
          component: PerfilRegistrar,
        },

        {
          path: "/perfiles/actualizar/:id_perfil",
          name: "perfil-actualizar",
          component: PerfilActualizar,
        },
        
        {
          path: "/perfiles/permisos/:id_perfil",
          name: "perfil-permiso",
          component: PerfilPermiso,
        },


        // foro
        {
          path: "/registroForows/:id_competencia",
          name: "registrar-forows",
          component: ForowsRegistrar,
        },

        {
          path: "/foro/:id_usuario/:id_competencia",
          name: "foro",
          component: ForoVuetify,
        },

        {
          path: "/mensaje/:id_forum",
          name: "mensaje-foro",
          component: MensajeVuetify,
        },



        /* ----- Senasoft ----- */
        // tablero
        {
          path: '/senasoft/tablero',
          name: 'tablero-senasoft',
          component: SenasoftTablero
        },


        // aliados
        { 
          path: "/aliados", 
          name: "aliado-gestionar", 
          component: AliadoGestionar 
        },

        {
          path: "/aliados/registrar",
          name: "aliado-registrar",
          component: AliadoRegistrar,
        },

        {
          path: "/aliados/detalles/:id_aliado",
          name: "aliado-detalles",
          component: AliadoDetalles,
        },
        
        {
          path: "/aliados/actualizar/:id_aliado",
          name: "aliado-actualizar",
          component: AliadoActualizar,
        },


        // categorias
        {
          path: "/categorias",
          name: "categoria-gestionar",
          component: CategoriaGestionar,
        },

        {
          path: "/categorias/registrar",
          name: "categoria-registrar",
          component: CategoriaRegistrar,
        },

        {
          path: "/categorias/detalles/:id_categoria",
          name: "categoria-detalles",
          component: CategoriaDetalles,
        },

        {
          path: "/categorias/actualizar/:id_categoria",
          name: "categoria-actualizar",
          component: CategoriaActualizar,
        },


        // competencias
        {
          path: "/competencias",
          name: "competencia-gestionar",
          component: CompetenciaGestionar,
        },

        {
          path: "/competencias/registrar",
          name: "competencia-registrar",
          component: CompetenciaRegistrar,
        },

        {
          path: "/competencias/detalles/:id_competencia",
          name: "competencia-detalles",
          component: CompetenciaDetalles,
        },

        {
          path: "/competencias/actualizar/:id_competencia",
          name: "competencia-actualizar",
          component: CompetenciaActualizar,
        },
        

        // categorias - competencia
        {
          path: "/categorias/asociar/:id_competencia",
          name: "categoria-asociar",
          component: CategoriaAsociar,
        },


        // cupos
        {
          path: "/cupos/asignados/:id_competencia",
          name: "cupo-asignado",
          component: CupoGestionarAsignado,
        },
        
        {
          path: "/cupos/asignados/detalles/:id_categoria",
          name: "cupo-detalle",
          component: CuposDetalles,
        },

        {
          path: "/cupos/:id_categoria/:id_competencia",
          name: "cupo-gestionar",
          component: CupoGestionar,
        },

        
        // participantes
        {
          path: "/participantes/detalles/:id_participante",
          name: "participante-detalle",
          component: ParticipanteDetalle,
        },

        {
          path: "/participantes/:id_competencia/:id_categoria",
          name: "participante-gestionar",
          component: ParticipanteGestionar,
        },
        

        // lideres
        {
          path: "/lideres/detalles/:id_lider",
          name: "lider-detalle",
          component: LiderDetalle,
        },

        {
          path: "/lideres/:id_competencia",
          name: "lider-gestionar",
          component: LiderGestionar,
        },

        {
          path: "/lideresCategoria/:id_competencia",
          name: "lider-categoria",
          component: LiderCategoria,
        },

        // reportes
        { 
          path: "/reportes", 
          name: "reporte", 
          component: SenasoftReporte 
        },


        // personas
        {
          path: "/personas/registrar/:experto",
          name: "personas-registrar",
          component: PersonaRegistrar,
        },

        {
          path: "/personas/editar/:id",
          name: "personas-editar",
          component: PersonaRegistrar,
        },

        {
          path: "/personas",
          name: "personas-gestionar",
          component: PersonasGestionar,
        },



        /* ----- WorldSkills ----- */
        // tablero
        {
          path: "/worldskills/tablero",
          name: "tablero-worldskills",
          component: TableroWorldSkills,
        },

        
        // habilidades
        {
          path: "/habilidades",
          name: "habilidad-gestionar",
          component: HabilidadGestionar,
        },

        {
          path: "/habilidades/registrar",
          name: "habilidad-registrar",
          component: HabilidadRegistrar,
        },

        {
          path: "/habilidades/detalles/:id_habilidad",
          name: "habilidad-detalles",
          component: HabilidadDetalle,
        },

        {
          path: "/habilidades/actualizar/:id_habilidad",
          name: "habilidad-actualizar",
          component: HabilidadActualizar,
        },

        {
          path: "/habilidades/documentos/:id_habilidad",
          name: "habilidad-documentos",
          component: HabilidadDocumento,
        },
        
        {
          path: "/habilidades/asignar/:id_competencia",
          name: "asignar-habilidad",
          component: HabilidadAsignar,
        },


        // competencias
        {
          path: "/competenciasws/gestionar",
          name: "competenciaws-gestionar",
          component: CompetenciaWsGestionar,
        },

        {
          path: "/competenciasws/registrar",
          name: "competenciaws-registrar",
          component: CompetenciaWsRegistrar,
        },

        {
          path: "/competenciasws/detalles/:id_competencia",
          name: "competenciaws-detalles",
          component: CompetenciaWsDetalles,
        },

        {
          path: "/competenciasws/actualizar/:id_competencia",
          name: "competenciaws-actualizar",
          component: CompetenciaWsActualizar,
        },

        {
          path: "/competenciasws/documentos/:id_competencia",
          name: "competenciaws-documentos",
          component: DocumentosGCompetencia,
        },
        
        {
          path: "/competenciasws/fases/:id_competencia",
          name: "competenciaws-fases",
          component: CompetenciaWsFases,
        },


        // sedes
        { 
          path: "/sedes", 
          name: "registrar-sede", 
          component: SedeRegistrar 
        },
        
        {
          path: "/sedes/gestionar/:id_competencia",
          name: "gestionar-sede",
          component: SedeGestionar,
        },

        {
          path: "/sedes/detalles/:id_sede",
          name: "detalles-sede",
          component: SedeDetalle,
        },

        {
          path: "/sedes/actualizar/:id_sede",
          name: "actualizar-sede",
          component: SedeActualizar,
        },

        {
          path: "/sedes/asignar/:id_competencia",
          name: "asignar-sede",
          component: SedeAsignar,
        },


        // participantes
        {
          path: "/participantesws/:id_competencia/:id_habilidad",
          name: "participantews-gestionar",
          component: ParticipanteWsGestionar,
        },

        {
          path: "/participantesws/detalles/:id_participante",
          name: "participantews-detalles",
          component: ParticipanteWsDetalles,
        },


        // ganadores
        {
          path: "/ganadoresws/gestionar/:id_competencia/:id_categoria",
          name: "ganador-gestionar",
          component: GanadorGestionar,
        },

        {
          path: "/ganadoresws/detalle/:id_evaluacion",
          name: "ganador-detalle",
          component: GanadorDetalle,
        },


        // expertos
        {
          path: "/expertosws/:id_competencia/:id_categoria",
          name: "expertows-gestionar",
          component: ExpertoGestionar,
        },

        {
          path: "/expertosws/detalles/:id_experto",
          name: "expertows-detalles",
          component: ExpertoDetalles,
        },

        {
          path: "/expertosnacionalws/:id_competencia/:id_categoria",
          name: "expertows-nacional-gestionar",
          component: ExpertoNacionalGestionar,
        },
        
        {
          path: "/expertosnacionalws/detalle/:id_experto",
          name: "expertows-nacional-detalles",
          component: ExpertoNacionalDetalle,
        },


        // acompanantes
        {
          path: "/acompanante/:id_competencia",
          name: "gestionar-acompanante",
          component: AcompananteGestionar,
        },

        {
          path: "/acompanante/:id_acompanante/:id_competencia",
          name: "detalles-acompanante",
          component: AcompananteDetalles,
        },


        // reportes
        { 
          path: "/worldskills/reportesws", 
          name: "reportesws", 
          component: WorldskillstReporte 
        },

        // RUTAS CAMPESENA
        
        //competencias
        {
          path: "/campesena/competencias",
          name: "campesena-competencia-gestionar",
          component: CampesenaCompetenciasGestionar,
        },
        {
          path: "/campesena/competencias/registrar",
          name: "campesena-competencia-registrar",
          component: CampesenaCompetenciasRegistrar,
        },
        {
          path: "/campesena/competencia/actualizar/:idCompetencia",
          name: "campesena-competencia-actualizar",
          component: CampesenaCompetenciaActualizar,
        },
        {
          path: "/campesena/competencia/detalles/:idCompetencia",
          name: "campesena-competencia-detalles",
          component: CampesenaCompetenciaDetalles,
        },
        
        //competencias-saberes
        {
          path: "/campesena/competencia/saberes/:idCompetencia",
          name: "campesena-competencia-saber-gestionar",
          component: CampesenaCompetenciaCategoriaGestionar,
        },
        
        //categorias
        {
          path: "/campesena/categorias/",
          name: "campesena-categoria-gestionar",
          component: CampesenaCategoriaGestionar,
        },
        {
          path: "/campesena/categorias/registrar",
          name: "campesena-categoria-registrar",
          component: CampesenaCategoriaRegistrar,
        },
        
        {
          path: "/campesena/categoria/actualizar/:idCategoria",
          name: "campesena-categoria-actualizar",
          component: CampesenaCategoriaActualizar,
        },
        {
          path: "/campesena/categoria/detalles/:idCategoria",
          name: "campesena-categoria-detalles",
          component: CampesenaCategoriaDetalles,
        },
        
        //aliados
        {
          path: "/campesena/aliados",
          name: "campesena-aliado-gestionar",
          component: CampesenaAliadosGestionar,
        },
        {
          path: "/campesena/aliados/registrar",
          name: "campesena-aliado-registrar",
          component: CampesenaAliadosRegistrar,
        },
        {
          path: "/campesena/aliado/detalles/:idAliado",
          name: "campesena-aliado-detalles",
          component: CampesenaAliadosDetalles,
        },
        {
          path: "/campesena/aliado/actualizar/:idAliado",
          name: "campesena-aliado-actualizar",
          component: CampesenaAliadosActualizar,
        },
        
        //Rutas saberes
        {
          path: "/campesena/saberes/registrar/:idCategoria",
          name: "campesena-saber-resgistrar",
          component: CampesenaSaberRegistrar,
        },
        {
          path: "/campesena/categoria/:idCategoria/saber/detalles/:idSaber",
          name: "campesena-saber-detalles",
          component: CampesenaSaberDetalles,
          props: true,
        },
        {
          path: "/campesena/categoria/:idCategoria/saber/actualizar/:idSaber",
          name: "campesena-saber-actualizar",
          component: CampesenaSaberActualizar,
        },
        
        {
          path: "/campesena/saberes/:idCategoria",
          name: "campesena-saber-gestionar",
          component: CampesenaSaberesGestionar,
        },
        
        //cupos 
        
        {
          path: "/campesena/cupos/competencia/:idCompetencia/saber/:idSaber",
          name: "campesena-cupo-gestionar",
          component: CampesenaCupoGestionar,
        },
        {
          path: "/campesena/competencias/saberes/cupo/:idCompetencia",
          name: "campesena-competencia-cupos-gestionar",
          component: CampesenaCompetenciasSaberesGestionar,
        },
        {
          path: "/campesena/competencias/saberes/cupo/detalle/:idCupo",
          name: "campesena-competencia-cupo-detalle",
          component: CampesenaCompetenciasSaberesDetalles,
        },
        
        
        //participantes
        {
          path: "/campesena/competencias/:idCompetencia/saber/:idSaber/cupo/asignado",
          name: "campesena-competencia-participantes",
          component: CampesenaCompetenciasParticipantesGestionar,
        },
        {
          path: "/campesena/competencias/:idCompetencia/participantes/:idParticipante",
          name: "campesena-competencia-participantes-detalle",
          component: CampesenaCompetenciasParticipantesDetalle,
        },
        
        // lideres campesena
        {
            path: "/campesena/competencias/:idCompetencia/lideres",
            name: "campesena-competencia-lideres-gestionar",
            component: CampesenaCompetenciaLideresGestionar,
        },
        {
            path: "/campesena/lider/:idLider",
            name: "campesena-competencia-lider-detalles",
            component: CampesenaCompetenciaLideresDetalles,
        },

        // dashboard
        {
            path: "/campesena/tablero",
            name: "campesena-tablero",
            component: CampesenaTablero,
        },

        //Reporte
        {
            path: "/campesena/reporte",
            name: "campesena-reporte",
            component: CampesenaReporte,
        }

        

      ]
    },
   
  ]
})


